import {
	apiClient,
	Button,
	ButtonGroup,
	PhoneFormInput,
	parser,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import type Phone from "../../types/Phone";
import orderFormLanguageResource from "./lang-resource";

interface PhoneFormData {
	phone: string;
}

interface Props {
	codeSent: (phone: Phone) => void;
	token: string;
	active: boolean;
}

const PhoneForm: React.FC<Props> = ({ codeSent, token, active }) => {
	const lang = useLanguageResource(orderFormLanguageResource);
	const phoneFormMethods = useForm<PhoneFormData>({
		defaultValues: { phone: "" },
	});
	const [submitting, setSubmitting] = useState(false);

	const submitPhoneNumber = async (data: PhoneFormData): Promise<void> => {
		setSubmitting(true);
		const parsedPhone = parser.phoneNumber.fromString(data.phone);
		if (parsedPhone.type === "success") {
			const { nationalNumber, countryCode } = parsedPhone;
			const response = await apiClient.post("/api/auth/widget/verify-phone", {
				token,
				phoneCountryCode: countryCode,
				phone: nationalNumber,
			});
			if (response.type === "success") {
				codeSent({ nationalNumber, phoneCountryCode: countryCode });
			} else {
				setSubmitting(() => {
					throw response.error;
				});
			}
		} else {
			setSubmitting(() => {
				throw new Error("Phone is not valid");
			});
		}
		setSubmitting(false);
	};

	useEffect(() => {
		document.getElementById("phone")?.focus();
	}, []);

	return (
		<>
			<h1 style={{ fontWeight: 500, fontSize: "2rem" }}>
				Påmelding / innlogging
			</h1>
			<FormProvider {...phoneFormMethods}>
				<form
					onSubmit={phoneFormMethods.handleSubmit(submitPhoneNumber)}
					data-test-id="phone-form"
				>
					<PhoneFormInput
						name="phone"
						required
						mobileOnly
						label={lang.inputs.phone}
						disabled={!active}
					/>
					{active && (
						<ButtonGroup>
							<Button type="submit" skin="primary" loading={submitting}>
								{lang.buttons.submitPhone}
							</Button>
						</ButtonGroup>
					)}
				</form>
			</FormProvider>
		</>
	);
};

export default PhoneForm;
